import React from 'react';

const Loading: React.FC = () => {
    return (
        <div className="loading-screen">
            <div className="spinner"></div>
        </div>
    );
};

export default Loading;